import type { MouseEvent } from 'react';
import { useEffect } from 'react';

import { useTransactionsColumns } from '@pages/AccountTransactions/useTransactionsColumns';
import { useGetVirtualBankMovementsSearch } from 'api';
import type { Movement } from 'api';

import { useOrganisationId } from 'hooks/context';

import { TRANSACTIONS_SEARCH_RESULTS_TEST_ID } from './constants';

import { SearchResults } from '../SearchResults';

type Props = {
  onRowClick?: (event: MouseEvent<HTMLElement>, rowData: Movement) => void;
  onSuccess: (transaction: Movement | undefined) => void;
  searchParams: any;
};

export const TransactionsSearchResults = ({
  searchParams,
  onSuccess
}: Props) => {
  const columnDefinitions = useTransactionsColumns();

  const organisationId = useOrganisationId<number>();

  const { data, error, isFetching, isSuccess } =
    useGetVirtualBankMovementsSearch(organisationId, searchParams);

  useEffect(() => {
    if (!isFetching && isSuccess) {
      onSuccess(data?.data?.[0]);
    }
  }, [isFetching, isSuccess, data, onSuccess]);

  const transactions = data?.data || [];

  if (transactions.length > 0 && !error && isSuccess) {
    return (
      <SearchResults
        idKey="id"
        title="Account Transactions"
        data={transactions}
        e2eId={TRANSACTIONS_SEARCH_RESULTS_TEST_ID}
        isFetching={isFetching}
        columnsDefinition={columnDefinitions}
      />
    );
  }
};
